if (!customElements.get('hg-bundle')) {
  customElements.define(
    'hg-bundle',
    class HgBundle extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.hg-bundle__inner')) {
          this.bind();
          return;
        }
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const fresh = html.querySelector('hg-bundle');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
              this.bind();
            }
          })
          .catch((error) => console.error(error));
      }

      bind() {
        this.addEventListener('change', () => this.update());
        this.querySelector('[data-add]').addEventListener('click', () => this.add());
        this.update();
      }

      formatMoney(cents) {
        const format = this.querySelector('[data-total]').dataset.moneyFormat;
        const amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
      }

      selected() {
        return [...this.querySelectorAll('.hg-bundle__item')]
          .map((item) => {
            const field = item.querySelector('.hg-bundle__variant');
            const option = field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
            const price = Number(option.dataset.price);
            item.querySelector('[data-item-price]').innerHTML = this.formatMoney(price);
            return { checked: item.querySelector('input[type="checkbox"]').checked, id: Number(field.value), price };
          })
          .filter((item) => item.checked);
      }

      update() {
        const items = this.selected();
        const total = items.reduce((sum, item) => sum + item.price, 0);
        this.querySelector('[data-total]').innerHTML = this.formatMoney(total);
        this.querySelector('[data-add]').disabled = items.length === 0;
      }

      add() {
        const button = this.querySelector('[data-add]');
        const error = this.querySelector('.hg-bundle__error');
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items: this.selected().map((item) => ({ id: item.id, quantity: 1 })) };
        error.hidden = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');

        // The subscription app patches window.fetch and adds the selected selling plan to every
        // cart add. Bundle items are always one-time purchases, so use an untouched fetch.
        const frame = document.createElement('iframe');
        frame.hidden = true;
        document.body.appendChild(frame);
        const plainFetch = frame.contentWindow.fetch.bind(frame.contentWindow);

        plainFetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) {
              error.textContent = state.description || state.message;
              error.hidden = false;
              return;
            }
            if (!cart) {
              window.location = routes.cart_url;
              return;
            }
            // A multi-item add does not return section HTML, so fetch the cart sections separately.
            const sections = cart.getSectionsToRender().map((section) => section.id).join(',');
            return fetch(`${window.location.pathname}?sections=${sections}`)
              .then((response) => response.json())
              .then((rendered) => {
                cart.classList.remove('is-empty');
                cart.renderContents({ sections: rendered });
              });
          })
          .catch((e) => console.error(e))
          .finally(() => {
            frame.remove();
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
          });
      }
    }
  );
}
